<template>
  <div style="background-color: #fff;">
    <center> <img :src="imgUrl" style="width: 100%;margin-bottom: -6px;"></center>
    <h2 style="text-align: center;padding: 15px 0px;font-weight: normal;">新闻动态</h2>
    <div class="demo">
      <NewsCard v-for="(val,i) in NewscardL" :key="i"
        :uid = "val['uid']"
        :title  = "val['title']"
        :time  = "val['time']"
        :detail = "val['detail']"
        :imgUrl = "val['imgUrl']"
      /> 
    </div>
  </div>
</template>

<script>
import NewsCard from "./NewsCard.vue"
export default {
  components: { NewsCard },
  data() {
    return {
      NewscardL:[],
      imgUrl: "",
    };
  },
  created() {
    this.$http.get("api/vue_support/get_newscard_all").then((response) => {
      // console.log(response.data.data)
      this.NewscardL = JSON.parse(response.data.data)
    });
    this.$http.get("api/vue_support/get_support_top_img").then((response) => {
      this.imgUrl = response.data.data
    });

  },

}
</script>

<style lang="less" scoped>

.demo{
  // display: inline-block;
  text-align: center;
  background-color: #fff;
}

</style>
